import defaultTemplate from './templates/default';
import errorTemplate from './templates/error';
import buttonTemplate from './templates/button';
import successTemplate from './templates/success';

export default {
  default: defaultTemplate,
  error: errorTemplate,
  success: successTemplate,
  button: buttonTemplate,
};